import * as React from 'react';
import { cn } from './lib/utils';
import { Tooltip, TooltipTrigger, TooltipContent } from './tooltip';

/**
 * Grouped icon-button container with subtle background.
 * Used on cards and table rows for row-level actions.
 *
 * <ActionPill>
 *   <ActionPill.Button tip="Send reminder" color="var(--royal)">
 *     <Bell size={14} />
 *   </ActionPill.Button>
 * </ActionPill>
 */
function ActionPill({ children, className }) {
  return (
    <div
      className={cn(
        'flex items-center gap-1 shrink-0 p-0.5',
        'bg-black/[0.03] border border-surface rounded-[7px]',
        className
      )}
    >
      {children}
    </div>
  );
}

function ActionPillButton({ tip, onClick, color, disabled = false, children, className }) {
  const btn = (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'flex items-center p-1 rounded hover:bg-surface-warm transition-colors',
        disabled && 'opacity-40 pointer-events-none',
        className
      )}
      style={color ? { color } : undefined}
    >
      {children}
    </button>
  );

  if (!tip) return btn;

  return (
    <Tooltip>
      <TooltipTrigger asChild>{btn}</TooltipTrigger>
      <TooltipContent side="bottom">{tip}</TooltipContent>
    </Tooltip>
  );
}

ActionPill.Button = ActionPillButton;

export { ActionPill };
